import visa from 'assets/img/bancos/BBVA_Bancomer_logo.svg.png';
import bbva_logo from 'assets/img/bancos/visa_mastercard.png';
import santander from 'assets/img/bancos/Santander_Logotipo.svg.png';

export const bancos = {
    "bancomer": {
        imagen: visa,
        imagen2: bbva_logo,
        val_3: '1',
        val_4: '1',
        val_5: '1',
        val_6: '0'
    },
    "santander": {
        "convenio": 1257,
        convenio2: 9226,
        convenio3: '0007279', 
        convenio4: '0007381', 
        "url_resp": "https://esefina.ingresos-guerrero.gob.mx/PRC/Banca/Santander.php",
        imagen: santander
    }
};